// src/auth/authConfig.js

import { PublicClientApplication } from '@azure/msal-browser';

// MSAL Configuration
export const msalConfig = {
  auth: {
    clientId: 'f6e22498-feb4-49b3-bfcd-d6934ecec039', // Azure AD Application (client) ID
    authority: 'https://login.microsoftonline.com/common', // Tenant or 'common' for multi-tenant apps
    redirectUri: 'http://localhost:3000', // URL to redirect after login
  },
  cache: {
    cacheLocation: 'sessionStorage', // Cache location ('sessionStorage' or 'localStorage')
    storeAuthStateInCookie: false, // Set true for IE 11 support
  },
};

// Create and export an MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);
